import {
  ApprovalRangeBoundsType,
  ApprovalSubType,
  ApprovalType,
  ApproverPolicy,
  IWorkflowProcessor,
  IWorkflowProcessorExtension,
  IWorkflowValidateOptions,
  IWorkflowValidateTransitionOptions,
  StatusType
} from "../PA.Core/PA.Core.IF.Workflow";
import {TPMEventBO} from "./TPMEventBO";
import {ASync} from "../PA.Core/Basic/ASync";
import {WB_UserRow} from "../PA.Core/PAdbSchemaRows";
import {WorkflowProcessor} from "../PA.Core/Workflow/WorkflowProcessor";
import {UserSecurityService} from "../PA.Security.Services/UserSecurityService";
import * as _ from 'lodash'
import {esWB_User} from "../PA.Core/PAdbSchema";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {IUsrContext} from "../PA.Core/PA.Core.IF.User";
import {Role_Super_User, Role_TPM_Event_Approver} from "../PA.Core/Security/Roles";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {TPMEventSpend} from "./TPMEventBO.ITPMEventSpend";
import {TPMEventWorkflowUtils} from "./TPMEventWorkflowUtils";
import {PaymentMethod_OffInvoice} from "../PA.TPM.Core/TPM.Constants";
import {NumberUtils} from "../PA.Core/Basic/Numbers";
import {WarningMessage_restate} from "../PA.Core/Basic/MessageUtils";
import {ApprovalService} from "../PA.MD.Services/ApprovalService";
import {DateUtils} from "../PA.Core/Basic/Dates";


export class TPMEventBOStandardWorkflowExtension
  implements
    IWorkflowProcessorExtension
{

  tpmEventBO: TPMEventBO
  userCtx: IUsrContext

  constructor(aTPMEventBO: TPMEventBO){
    this.tpmEventBO = aTPMEventBO
    this.userCtx  = PAEnvironment.getValue(PAEnvironment.UserContext)

  }

  get id(): string{
    return "TPMEventBOStandardWorkflowExtension"
  }

  OnLoad(aWfProcessor: IWorkflowProcessor): Promise<void> {
    const self = this

    return new Promise<void>((resolve, error) => {
      aWfProcessor.setPolicyFields({WorkflowVisible: true, CurrentStateVisible: true, NextStateVisible: true, NextStateEditable: true})
      resolve()
    })
  }


  GetApproverPolicy(aWfProcessor: IWorkflowProcessor): Promise<ApproverPolicy> {
    return ASync.resolve(ApproverPolicy.ApproverList)
  }

  LogTransitionCondition(aWfProcessor: IWorkflowProcessor): boolean {
    const self = this

    // Always log when server side.. (Bulk Approval)
    if(PAEnvironment.isNode())
      return true;

    if(aWfProcessor.CurrentState.StatusTypeRevised && aWfProcessor.NextState.StatusTypeApproved) {
      let prevApprSpend = <number>_.round(self.tpmEventBO.WB_TPMEvent.previous("APPROVED_SPEND"), 2)
      let currApprSpend = <number>_.round(self.tpmEventBO.WB_TPMEvent.cif.APPROVED_SPEND, 2)
      if(currApprSpend == prevApprSpend) {
        return false
      }
    }

    return true;
  }

  GetApproverList(aWfProcessor: IWorkflowProcessor): Promise<WB_UserRow[]> {
    let aWp: WorkflowProcessor = <WorkflowProcessor> aWfProcessor
    const self = this

    return new Promise<WB_UserRow[]>((resolve, error) => {

      let plnMgntId = self.tpmEventBO.WB_TPMEvent.WB_PlanRow.cif.WB_PLNMGMT_ID
      let wbCustId = self.tpmEventBO.WB_TPMEvent.cif.WB_CUST_ID_PLANNING
      let wbPeriodId = self.tpmEventBO.WB_TPMEvent.WB_PlanRow.cif.WB_PERIOD_ID
      UserSecurityService.getResponsibleUserListWithPlanManagement(wbCustId, wbPeriodId, [Role_TPM_Event_Approver],[],0,[plnMgntId])
        .then((usersIds) => {
          if(_.isEmpty(usersIds)){
            resolve([])
            return
          }

          return aWfProcessor.dbContext.findUsingCache(esWB_User, usersIds)
        })
        .then((userRecs: WB_UserRow[]) => {
          resolve(userRecs)
        })
        .catch((err) => {
          error(err)
        })

    })

  }


  Validate(aWfProcessor: IWorkflowProcessor, options?: IWorkflowValidateTransitionOptions): Promise<void> {
    const self = this
    const opts: IWorkflowValidateTransitionOptions = options || {}

    return new Promise<void>((resolve, error) => {

      // Determine if we defer the validation


      if((!opts.bSkipCalcCheck) && self._validateRequiresCalc(aWfProcessor, opts)){
        aWfProcessor.setPolicyFields({ValidateEnabled: false, SaveEnabled: false})
        if(aWfProcessor.CurrentState.StatusTypeIsPostApproval){
          aWfProcessor.setStateType(StatusType.Revised, undefined)
            .then((ignore) => {
              resolve()
            })
            .catch((err) => {
              error(err)
            })
        } else {
          resolve()
        }
        return
      }

      self._validate(aWfProcessor, opts)
        .then((ignore) => {
          resolve()
        })
        .catch((err) => {
          error(err)
        })

    })
  }

  //<editor-fold desc="Validate Functions">

  private _validate(aWfProcessor: IWorkflowProcessor, options?: IWorkflowValidateTransitionOptions): Promise<void> {
    const self = this
    const opts = options || {}

    return new Promise<void>((resolve, error) => {

      //  Validate only State Transitions
      let NextState = aWfProcessor.NextState

      // Check if Next State is overriden.
      if(opts.UsingNextState){
        NextState = opts.UsingNextState
      } else if (opts.UsingNextStateType){
        let optsState = aWfProcessor.getStateType(opts.UsingNextStateType)
        if(_.isArray(optsState)){ optsState = _.first(optsState)}
        if(optsState){
          NextState =optsState
        }
      }
      let NextStateId = NextState.cif.WB_STATUS_ID

      if(aWfProcessor.CurrentStateId == NextStateId){
        resolve()
        return
      }

      let validateFunction: (a: IWorkflowProcessor)=> Promise<void> = undefined

      switch (true) {
        case NextState.StatusTypeInitial:
        case NextState.StatusTypeRejected:
        case NextState.StatusTypeRevisionDenied:
          // No Validation
          break;

        case NextState.StatusTypeApproved:
          // Add Validation Function
          validateFunction = self._validateStateTransition_Approved.bind(self);
          break;

        case NextState.StatusTypePendingApproval:
        case NextState.StatusTypeRevised:
          // No Validation
          break;

        case NextState.StatusTypeCancelled:
          validateFunction = self._validateStateTransition_Cancel.bind(self);
          break;

        case NextState.StatusTypeClosed:
          validateFunction = self._validateStateTransition_Closed.bind(self)
          break;
      }

      if(!_.isFunction(validateFunction)){
        resolve()
        return
      }

      validateFunction(aWfProcessor)
        .then((ignore) => {
          resolve()
        })
        .catch((err) => {
          error(err)
        })

    })
  }

  private _validateStateTransition_Approved(aWfProcessor: IWorkflowProcessor): Promise<void> {
    const self = this

    async function runValidateStateTransition_ApprovedAsync() {
      let bo = self.tpmEventBO
      let evt = bo.WB_TPMEvent
      let pln = evt.WB_PlanRow

      let ApprovalThresholdPcnt: number = 0.0
      let ApprovalThresholdAmt: number = 10000

      let aWbBusinessUnitId = evt.WB_PlanRow.WB_PlanTypeRow.cif.WB_BUSINESSUNIT_ID
      let dateRange = DateUtils.RangeUnion(evt.InStore.Range, evt.Shipment.Range)
      let drApproval = await ApprovalService.getApprovalRule(aWbBusinessUnitId, ApprovalType.Event, ApprovalSubType.Threshold,
        {
          effectiveDateRange: dateRange,
          WB_CUST_ID: pln.cif.WB_CUST_ID_PLANNING,
          WB_EVTTYPE_ID: evt.cif.WB_EVTTYPE_ID
        })

      if(drApproval){
        ApprovalThresholdAmt = _.toNumber(drApproval.cif.REVISED_THRESHOLD_FIXED_AMT) || 0
        ApprovalThresholdPcnt= _.toNumber(drApproval.cif.REVISED_THRESHOLD_PCNT) || 0
      }

      //  Check Planned Spend vs Approved Spend
      TPMEventWorkflowUtils.EventSpend_updateTotals(self.tpmEventBO)
      let PlannedSpend =  TPMEventWorkflowUtils.Event_getSpendingTotalForApproval(self.tpmEventBO)
      let ApprovedSpend = evt.cif.APPROVED_SPEND || 0
      let ApprovedSpendWithThreshold = (ApprovedSpend * (1+ApprovalThresholdPcnt)) + ApprovalThresholdAmt
      if(aWfProcessor.CurrentState.StatusTypeIsPreApproval){
        ApprovedSpendWithThreshold = ApprovedSpend
      }

      let arrApprovalWarningMessageTexts: string[] = []
      let bCurrentUserApprover: boolean = false
      let usrCtx: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
      if(usrCtx){
        bCurrentUserApprover = usrCtx.hasRoleId(Role_TPM_Event_Approver, evt.cif.WB_CUST_ID_PLANNING)
      }

      PlannedSpend = _.round(PlannedSpend, 2)
      ApprovedSpend = _.round(ApprovedSpend, 2)

      if(PlannedSpend > ApprovedSpend){
        let sPlannedSpend = NumberUtils.formatMoney(PlannedSpend)
        let sApprovedSpend = NumberUtils.formatMoney(ApprovedSpend)
        let sApprovedSpendWithThreshold = NumberUtils.formatMoney(ApprovedSpendWithThreshold)
        let sMsg = `Planned Spend, ${sPlannedSpend}, exceeds Approved Spend, ${sApprovedSpend}.`
         aWfProcessor.addStatusHistoryLogMessage("Approval", sMsg)
         arrApprovalWarningMessageTexts.push(sMsg)
        if(PlannedSpend <= ApprovedSpendWithThreshold){
          sMsg = `Approved Spend ${sApprovedSpend} under threshold ${sApprovedSpendWithThreshold}.`
          aWfProcessor.addStatusHistoryLogMessage("Approval", sMsg)
          arrApprovalWarningMessageTexts.push(sMsg)
        }
      }

      ApprovedSpendWithThreshold = _.round(ApprovedSpendWithThreshold, 2)
      if((PlannedSpend > ApprovedSpendWithThreshold) && (!bCurrentUserApprover)){

        aWfProcessor.addStatusHistoryLogMessage("Approval", "Event Approval Required in the Main Tab by Approver")
        arrApprovalWarningMessageTexts.push("Event Approval Required in the Main Tab by Approver")
        // Set the next State
        if(aWfProcessor.CurrentState.StatusTypeIsPreApproval){
          //
          await aWfProcessor.setStateType(undefined, StatusType.PendingApproval)
        } else {
          //
          await aWfProcessor.setStateType(undefined, StatusType.Revised)

          // find Tactics Requesting Approval, and set to Requesting Approval instead of Approved..
          for(let idxSpnd in bo.TPMEventSpends) {
            let aSpend: TPMEventSpend = <TPMEventSpend> bo.TPMEventSpends[idxSpnd]
            if(!aSpend.isActive){ return }
            if(aSpend.PrimaryWorkflowProcessor.CurrentState.StatusTypeIsPreApproval
                && aSpend.PrimaryWorkflowProcessor.NextState.StatusTypeApproved){
              await aSpend.PrimaryWorkflowProcessor.setStateType(undefined, StatusType.PendingApproval)
            }
          }

        }
      } else {
        // Approval should go through
        if(!aWfProcessor.CurrentState.StatusTypeIsPreApproval){
          // Check if there are any Tactics in Initial, and add warning message
          let arrTacticsCouldRequireTransition: string[] = []
          _.forEach(bo.TPMEventSpends, (aSpend: TPMEventSpend) => {
            if(!aSpend.isActive){ return }
            if(aSpend.PrimaryWorkflowProcessor.NextState.StatusTypeInitial){
              arrTacticsCouldRequireTransition.push(`Tactic ${aSpend.TPMEventSpendRow.cif.EVENT_SPEND_ID}, ${aSpend.TPMEventSpendRow.cif.EVENT_SPEND_NAME}`)
            }
          })
          if(arrTacticsCouldRequireTransition.length){
            arrApprovalWarningMessageTexts.push("Tactic(s) will remain in Initial unless transitioned to Approved before Event Approval.\n" +
                                                arrTacticsCouldRequireTransition.join("\n"))
          }

        }
      }

      if(arrApprovalWarningMessageTexts.length){
        let sMsg = arrApprovalWarningMessageTexts.join("\n")
        WarningMessage_restate(bo.ValidateMessageProvider, true,  "ApprovalWarnings", {Title: "Approval Warnings", Desc: sMsg })
      }


    }

    return runValidateStateTransition_ApprovedAsync()

  }

  private _validateStateTransition_Cancel(aWfProcessor: IWorkflowProcessor): Promise<void> {
    const self = this

    async function runValidateStateTransition_CancelAsync() {
      let arrEventSpends: TPMEventSpend[] = <any>_.filter(self.tpmEventBO.TPMEventSpends, (a) => a.isActive)
      for (let anEventSpend of arrEventSpends) {
        if (!anEventSpend.PrimaryWorkflowProcessor) {
          return
        }

        await anEventSpend.PrimaryWorkflowProcessor.ValidateTransition({UsingNextStateType: StatusType.Cancelled})
        // Copy Messages from Tactic Validation
        aWfProcessor.WorkflowMessageProvider.addMessages(anEventSpend.PrimaryWorkflowProcessor.WorkflowMessageProvider.Messages)
      }

      // Could Validate Payments at the Event Level.. to improve performance... if needed.(1 SQL call instead of multiple).

    }

    return runValidateStateTransition_CancelAsync()
  }

  private _validateStateTransition_Closed(aWfProcessor: IWorkflowProcessor): Promise<void> {
    const self = this

    async function runValidateStateTransition_ClosedAsync() {
      let arrEventSpends: TPMEventSpend[] = <any>_.filter(self.tpmEventBO.TPMEventSpends, (a) => a.isActive)
      for (let anEventSpend of arrEventSpends) {
        if (!anEventSpend.PrimaryWorkflowProcessor) {
          return
        }

        await anEventSpend.PrimaryWorkflowProcessor.ValidateTransition({UsingNextStateType: StatusType.Closed})
        // Copy Messages from Tactic Validation
        aWfProcessor.WorkflowMessageProvider.addMessages(anEventSpend.PrimaryWorkflowProcessor.WorkflowMessageProvider.Messages)
      }
    }

    return runValidateStateTransition_ClosedAsync()

  }

  private _validateRequiresCalc(aWfProcessor: IWorkflowProcessor, options?: IWorkflowValidateTransitionOptions): boolean {
    const self = this
    const opts: IWorkflowValidateTransitionOptions = options || {}

    if(self.userCtx.hasRoleId(Role_Super_User, self.tpmEventBO.WB_TPMEvent.cif.WB_CUST_ID_PLANNING)
      && aWfProcessor.NextState.StatusTypeClosed){
      return false
    }

    if((!aWfProcessor.CurrentState.StatusTypeIsPostApproval)
      && aWfProcessor.NextState.StatusTypeCancelled){
      return false
    }

    if(!aWfProcessor.NextState.StatusTypeIsPostApproval){
      return false
    }

    return true

  }
  //</editor-fold>


  OnValidatationSucess(aWfProcessor: IWorkflowProcessor, options?: IWorkflowValidateOptions): Promise<void> {
    const self = this
    const opts = options || {}

    return new Promise<void>((resolve, error) => {

      let NextState = aWfProcessor.NextState
      let NextStateId = NextState.cif.WB_STATUS_ID

      let onValidateSuccessFunction: (a: IWorkflowProcessor)=> Promise<void> = undefined

      switch (true) {
        case NextState.StatusTypeInitial:
        case NextState.StatusTypeRejected:
        case NextState.StatusTypeRevisionDenied:
          // No Function
          break;

        case NextState.StatusTypeApproved:
          // Add Validation Function
          onValidateSuccessFunction = self._onValidateSuccess_Approved.bind(self);
          break;

        case NextState.StatusTypePendingApproval:
        case NextState.StatusTypeRevised:
          // No Validation
          break;

        case NextState.StatusTypeCancelled:
          onValidateSuccessFunction = self._onValidateSuccess_Cancel.bind(self);
          break;

        case NextState.StatusTypeClosed:
          onValidateSuccessFunction = self._onValidateSuccess_Closed.bind(self)
          break;
      }

      if(!_.isFunction(onValidateSuccessFunction)){
        resolve()
        return
      }

      onValidateSuccessFunction(aWfProcessor)
        .then((ignore) => {
          resolve()
        })
        .catch((err) => {
          error(err)
        })
    })
  }

  //<editor-fold desc="OnValidate Success Functions">
  private _onValidateSuccess_Approved(aWfProcessor: IWorkflowProcessor): Promise<void> {
    const self = this
    return new Promise<void>((resolve, error) => {

      async function RunOnValidateSuccess_Approved(){
        let bo = self.tpmEventBO
        let evt = bo.WB_TPMEvent

        let CurrentState= aWfProcessor.CurrentState

        if(CurrentState.StatusTypeIsPreApproval){

          for(let iSpend of bo.TPMEventSpends) {
            let aSpend: TPMEventSpend = <any>iSpend
            let SpendWfProcessor = aSpend.PrimaryWorkflowProcessor
            SpendWfProcessor.addStatusHistoryLogMessage("TacticApproval", "Tactic" +aSpend.TPMEventSpendRow.cif.EVENT_SPEND_ID+ " has been approved.")
            await SpendWfProcessor.setStateType(StatusType.Approved, StatusType.Approved)
          }

        } else {

          for(let iSpend of bo.TPMEventSpends){
            let aSpend: TPMEventSpend = <any> iSpend
            let evts = aSpend.TPMEventSpendRow
            let SpendWfProcessor = aSpend.PrimaryWorkflowProcessor
            let SpendCurState = SpendWfProcessor.CurrentState
            let SpendNextState = SpendWfProcessor.NextState

            //
            switch (true) {
              case SpendNextState.StatusTypeIsRequestingApproval:
              case SpendNextState.StatusTypeApproved:
                if(SpendCurState.StatusTypeIsPreApproval) {
                  aWfProcessor.addStatusHistoryLogMessage("TacticApproval", "Tactic " +evts.cif.EVENT_SPEND_ID+ " has been approved.")
                  if(!_.isEmpty(aSpend.PrimaryWorkflowProcessor.WorkflowStatusHistory))
                    SpendWfProcessor.addStatusHistoryLogMessage("TacticApproval", "Tactic " +evts.cif.EVENT_SPEND_ID+ " has been approved.")
                }
                await SpendWfProcessor.setStateType(StatusType.Approved, StatusType.Approved)
                break;
              case SpendNextState.StatusTypeClosed:
                await SpendWfProcessor.setStateType(StatusType.Closed, StatusType.Closed)
                break;
              case SpendNextState.StatusTypeCancelled:
                await SpendWfProcessor.setStateType(StatusType.Cancelled, StatusType.Cancelled)
                break;
            }
          }
        }

        TPMEventWorkflowUtils.EventSpend_updateApprovedSpend(bo)
      }

      RunOnValidateSuccess_Approved()
        .then((ignore) => {
          resolve()
        })
        .catch((err) => {
          error(err)
        })
    })
  }

  private _onValidateSuccess_Closed(aWfProcessor: IWorkflowProcessor): Promise<void> {
    const self = this
    return new Promise<void>((resolve, error) => {

      async function RunOnValidateSuccess_Closed(){
        let bo = self.tpmEventBO
        let evt = bo.WB_TPMEvent

        for(let iSpend of bo.TPMEventSpends){
          let aSpend: TPMEventSpend = <any> iSpend
          let SpendCurState = aSpend.PrimaryWorkflowProcessor.CurrentState
          let SpendWfProcessor = aSpend.PrimaryWorkflowProcessor

          switch(true){
            case SpendCurState.StatusTypeInitial:
            case SpendCurState.StatusTypePendingApproval:
            case SpendCurState.StatusTypeApproved:
              await SpendWfProcessor.setStateType(StatusType.Closed, StatusType.Closed)
              aSpend.TPMEventSpendRow.cif.PAID_IN_FULL_IND = '1'
              break;

            case SpendCurState.StatusTypeClosed:
              aSpend.TPMEventSpendRow.cif.PAID_IN_FULL_IND = '1'
              break;

            case SpendCurState.StatusTypeCancelled:
            case SpendCurState.StatusTypeClosed:
              // No Change
              break;
          }
        }

      }

      RunOnValidateSuccess_Closed()
        .then((ignore) => {
          resolve()
        })
        .catch((err) => {
          error(err)
        })
    })
  }

  private _onValidateSuccess_Cancel(aWfProcessor: IWorkflowProcessor): Promise<void> {
    const self = this
    return new Promise<void>((resolve, error) => {

      async function RunOnValidateSuccess_Cancel(){
        let bo = self.tpmEventBO
        let evt = bo.WB_TPMEvent

        for(let iSpend of bo.TPMEventSpends){
          let aSpend: TPMEventSpend = <any> iSpend
          let SpendWfProcessor = aSpend.PrimaryWorkflowProcessor
          //let SpendCurState = SpendWfProcessor.CurrentState

          await SpendWfProcessor.setStateType(StatusType.Cancelled, StatusType.Cancelled)
        }

      }

      RunOnValidateSuccess_Cancel()
        .then((ignore) => {
          resolve()
        })
        .catch((err) => {
          error(err)
        })
    })
  }
  //</editor-fold>


  OnSaved(aWfProcessor: IWorkflowProcessor): Promise<void> {
    const self = this

    return new Promise<void>((resolve, error) => {
      if(!self._validateRequiresCalc(aWfProcessor)){
        resolve()
        return
      }

      //
      // Calculate, setting "skip" save..(already Saved)
      //
      //
      let primaryWfProcessor: IWorkflowProcessor = undefined
      let bExit = false

      self.tpmEventBO.EventCalculator.Calculate({bSkipSave: true})
        .then((ignore)=> {
          // At this point the BO has been reloaded...
          // The WfProcessor is invalid.. have to get it from the Event..
          primaryWfProcessor = self.tpmEventBO.PrimaryWorkflowProcessor

          return primaryWfProcessor.Validate({bSkipCalcCheck: true})
        })
        .then((ignore) => {

          // Check Validate Messages to determine if we Save again ?
          self.tpmEventBO.ValidateMessageProvider.addMessages(primaryWfProcessor.WorkflowMessageProvider.Messages)
          if (primaryWfProcessor.WorkflowMessageProvider.countMessages(MessageType.Error) > 0) {
            // Done Save
            bExit = true
            return
          }

          async function RunEventSpendWorkflowProcessorValidateFunctions(): Promise<void> {
            //
            for (let iEventSpend of self.tpmEventBO.TPMEventSpends) {
              let oEventSpend: TPMEventSpend = <any>iEventSpend
              for (let aSpndWfProcessor of oEventSpend.WorkflowProcessors) {
                await aSpndWfProcessor.Validate({})
                self.tpmEventBO.ValidateMessageProvider.addMessages(aSpndWfProcessor.WorkflowMessageProvider.Messages)

                if (aSpndWfProcessor.WorkflowMessageProvider.countMessages(MessageType.Error) > 0) {
                  // Don't Save
                  bExit = true
                }
              }
            }

          }

          return RunEventSpendWorkflowProcessorValidateFunctions()
        })
        .then((ignore) => {

          if (bExit)
            return

          async function RunWorkflowProcessorSaveFunctions(): Promise<void> {

            await primaryWfProcessor.Save(false)
            for (let iEventSpend of self.tpmEventBO.TPMEventSpends) {
              let oEventSpend: TPMEventSpend = <any>iEventSpend
              for (let aSpndWfProcessor of oEventSpend.WorkflowProcessors) {
                await aSpndWfProcessor.Save(false)
              }
            }

            for (let iEventSpend of self.tpmEventBO.TPMEventSpends) {
              let oEventSpend: TPMEventSpend = <any>iEventSpend
              for (let aSpndWfProcessor of oEventSpend.WorkflowProcessors) {
                await aSpndWfProcessor.OnSaved()
              }
            }

          }

          return RunWorkflowProcessorSaveFunctions()
        })
        .then((ignore) => {
          resolve()
        })
        .catch((err) => {
          error(err)
        })
    })
  }

  OnReloaded(aWfProcessor: IWorkflowProcessor): Promise<void> {
    const self = this

    return new Promise<void>((resolve, error) => {
      console.log(self.id, ": OnReloaded")
      resolve()
    })
  }


}
